export * from "./consent-templates.ts";
export * from "./legal.ts";

export const APP_NAME = "Klyra";
export const DEFAULT_LOCALE = "ar" as const;
export const DEFAULT_TIMEZONE = "Asia/Baghdad" as const;
export const DEFAULT_CURRENCY = "IQD" as const;

export const SESSION_DURATION_MS = 15 * 60 * 1000; // 15 minutes
export const REFRESH_TOKEN_DURATION_MS = 7 * 24 * 60 * 60 * 1000; // 7 days
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_ROTATION_DAYS = 90;
export const ACCOUNT_LOCKOUT_THRESHOLD = 5;
export const ACCOUNT_LOCKOUT_DURATION_MS = 30 * 60 * 1000; // 30 min

export const AUDIT_LOG_RETENTION_YEARS = 10;
export const PATIENT_DATA_RETENTION_YEARS = 7;

export const VOICE_COMMAND_LATENCY_TARGET_MS = 2000;
export const API_LATENCY_P95_TARGET_MS = 500;

export const MAX_UPLOAD_SIZE_MB = 25;
export const ALLOWED_IMAGE_TYPES = [
	"image/jpeg",
	"image/png",
	"image/webp",
	"image/heic",
] as const;

export const ERROR_CODES = {
	UNAUTHORIZED: "UNAUTHORIZED",
	FORBIDDEN: "FORBIDDEN",
	NOT_FOUND: "NOT_FOUND",
	VALIDATION_FAILED: "VALIDATION_FAILED",
	CONFLICT: "CONFLICT",
	RATE_LIMITED: "RATE_LIMITED",
	TENANT_MISMATCH: "TENANT_MISMATCH",
	SUBSCRIPTION_EXPIRED: "SUBSCRIPTION_EXPIRED",
	QUOTA_EXCEEDED: "QUOTA_EXCEEDED",
	INTERNAL_ERROR: "INTERNAL_ERROR",
	EXTERNAL_SERVICE_ERROR: "EXTERNAL_SERVICE_ERROR",
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];
